module.exports = __webpack_public_path__ + "static/img/location.02220e28.svg";